import React, { useState } from 'react';
import MaterialSearchBar from 'material-ui-search-bar';

const CustomSearchBar: React.FC = () => {
  // State to hold search value
  const [searchValue, setSearchValue] = useState<string>('');

  // Function to handle search request
  const handleSearch = () => {
    console.log("Search request for:", searchValue);
    // Add your search logic here
  };

  // Function to clear search
  const handleCancel = () => {
    setSearchValue('');
  };

  return (
    <div className="searchbar">
      {/* <MaterialSearchBar
        value={searchValue} // Controlled input value
        onChange={(newValue) => setSearchValue(newValue)} // Update state on input change
        onRequestSearch={handleSearch} // Trigger search on submit
        onCancelSearch={handleCancel} // Handle cancel action
        placeholder="Search" // Custom placeholder
        style={{ border: '1px solid #5D5D5D' }}
       className='globalsearch'
      /> */}
    </div>
  );
}

export default CustomSearchBar;
